var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Animation } from '../../../../lib/classes/animation';
import { AssetsLoader } from '../../../../lib/classes';
import coinSrc from '../../../../img/coin-66x66.png';
var CoinsEffect = /** @class */ (function (_super) {
    __extends(CoinsEffect, _super);
    function CoinsEffect(props) {
        var _this = _super.call(this, props) || this;
        _this.maxTime = 3000;
        _this.coins = []; // [x, y, done]
        var _a = _this.props, x = _a.x, y = _a.y;
        _this.vx = 0.1;
        _this.vy = 0.5;
        _this.coins.push([x - 15, y, false]);
        _this.coins.push([x + 5, y, false]);
        _this.coins.push([x + 25, y, false]);
        _this.coins.push([x + -5, y + 20, false]);
        _this.coins.push([x + 15, y + 20, false]);
        _this.img = AssetsLoader.getAsset(coinSrc);
        return _this;
    }
    CoinsEffect.prototype.upd = function (dt) {
        _super.prototype.upd.call(this, dt);
        if (this.done)
            return;
        var allDone = true;
        for (var i = 0; i < this.coins.length; i++) {
            var _a = this.coins[i], x = _a[0], y = _a[1], done = _a[2];
            var _b = this.props, x2 = _b.x2, y2 = _b.y2;
            if (!done)
                allDone = false;
            if (this.time > i * 25 + 500) {
                x = move(x, x2, dt * this.vx);
                y = move(y, y2, dt * this.vy);
            }
            this.coins[i] = [x, y, x === x2 && y === y2];
        }
        if (allDone) {
            if (this.props.onDone) {
                this.props.onDone();
                this.props.onDone = null;
            }
            this.done = allDone;
        }
    };
    CoinsEffect.prototype.draw = function (scene) {
        var _this = this;
        if (this.time < 1000) {
            var _a = this.props, x = _a.x, y = _a.y, coins = _a.coins;
            scene.save();
            scene.fillStyle('#fff');
            scene.shadowColor('rgba(0,0,0,0.75)');
            scene.shadowBlur(4);
            this.fillTextXY(scene, "+".concat(coins), x, y + 70, 0, 25, 0.1, 'Arial', 'bold');
            scene.restore();
        }
        this.coins.forEach(function (_a) {
            var x = _a[0], y = _a[1], done = _a[2];
            return !done && _this.drawCoin(scene, 0.5, x, y);
        });
    };
    CoinsEffect.prototype.drawCoin = function (scene, scale, x, y, alpha) {
        if (alpha === void 0) { alpha = 0.95; }
        if (!this.img.complete)
            return;
        scene.ctx.globalAlpha = alpha;
        var w = this.img.width;
        var h = this.img.height;
        var w2 = Math.min(300, w * scale);
        var h2 = w2 * (h / w);
        scene.drawImage(this.img, 0, 0, w, h, x - w2 / 2, y - h2 / 2, w2, h2);
        scene.ctx.globalAlpha = 1;
    };
    return CoinsEffect;
}(Animation));
export { CoinsEffect };
function move(value, target, step) {
    if (value < target) {
        value = Math.min(target, value + step);
    }
    if (value > target) {
        value = Math.max(target, value - step);
    }
    return value;
}
